
import { NoseurObject } from "@rivtn/noseur";
import { PloutousBaseService, PloutousTrail } from "./PloutousBaseService";

export interface ITransactionChargePayment {
    status: number;
    external_id: string;
    payment_amount: number;
    trails: PloutousTrail[];
    extra_data: {
        payment_processor_name: string;
    }
}

export interface IManagedTransactionChargePayment {
    url: string;
}

export class TransactionChargePaymentService extends PloutousBaseService {

    protected static instance: TransactionChargePaymentService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!TransactionChargePaymentService.instance) TransactionChargePaymentService.instance = new TransactionChargePaymentService();
        return TransactionChargePaymentService.instance;
    }

    queryTransactionChargePayments(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/transaction/charge/payment", { query: this.normalizeParams(params) }));
    }

}
